import React from 'react';

import MuteButton from './MuteButton';


function FeaturedClipControls(props) {
  const { isFeaturedClip, isMuted, onMute } = props;

  return (
    <div className="featured-controls">
      <MuteButton isFeaturedClip={isFeaturedClip} isMuted={isMuted} onMute={onMute} />
    </div>
  );
}

export default FeaturedClipControls;
